import axios from "axios";
import { Base_Url } from "./apiUrl";

// 创建 axios 实例
const apiClient = axios.create({
  baseURL: Base_Url,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器
apiClient.interceptors.request.use(
  (config) => {
    // 统一添加 token（如果存在）
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // 添加时间戳防止缓存
    if (config.method === 'get') {
      config.params = {
        ...config.params,
        qid: Date.now()
      };
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
apiClient.interceptors.response.use(
  (response) => {
    // 返回完整的 response 对象，保持 axios 标准行为
    // 组件代码可以使用 res.data.xxx 访问响应数据
    return response;
  },
  (error) => {
    // 统一错误处理
    let errorMessage = 'Unknown Error';
    let statusCode = null;
    
    if (error.response) {
      // 服务器返回了错误状态码
      statusCode = error.response.status;
      
      switch (statusCode) {
        case 400:
          errorMessage = 'Bad Request';
          break;
        case 401:
          errorMessage = 'Unauthorized - Please login';
          // 可以在这里清除登录状态或跳转登录页
          break;
        case 403:
          errorMessage = 'Forbidden';
          break;
        case 404:
          errorMessage = 'Resource Not Found';
          break;
        case 500:
          errorMessage = 'Server Error';
          break;
        case 502:
          errorMessage = 'Bad Gateway';
          break;
        case 503:
          errorMessage = 'Service Unavailable';
          break;
        default:
          errorMessage = `HTTP Error ${statusCode}`;
      }
      
      console.error(`[API Error] ${statusCode}: ${error.config?.url}`, error.response.data);
    } else if (error.request) {
      // 请求已发出但没有收到响应
      errorMessage = 'Network Error - Please check your connection';
      console.error('[API Error] Network Error:', error.config?.url);
    } else {
      // 其他错误
      errorMessage = error.message || 'Unknown Error';
      console.error('[API Error]:', errorMessage);
    }
    
    return Promise.reject({
      success: false,
      error: errorMessage,
      status: statusCode
    });
  }
);

export default apiClient;
